(function() {
// 注册组件
SR.component.extend('speak', speak);

function speak() {
    var $wrapper = SR.dom.$wrapper;
    var $scrollWrap = SR.dom.$scrollWrap;
    var $historyWrapper = SR.dom.$historyWrapper;
    var scrollAnimateDuration = SR.data.scrollAnimateDuration;
    var playing = 'playing';
    var pause = 'pause';
    var uploadVoiceError = 'msg-error';
    var vocieUploading = 'msg-loading';
    var API = SR.data.customerServiceAPI;
    var appcid = SR.util.urlParam('appcid');
    var sn = SR.permissions.sn;
    var uid = SR.data.guid || SR.data.jsid;
    var xhrTimeout = 3000;

    SR.dom.$body.on('click.speak', '.J_playSpeakVoice', function(e) {
        var $allAudio = $('.speak-voice-wrap');
        var $wrap = $(this).parents('.content');
        var $audio = $wrap.find('.speak-audio');
        var $playBtn = $wrap.find('.play-btn');
        
        $allAudio.each(function() {
            var $me = $(this);
            var $iAudio = $me.find('.speak-audio');
            if ($iAudio.length) {
                $me.find('.play-btn').removeClass(playing + ' ' + pause);
                $iAudio.get(0).pause();
                $iAudio.get(0).currentTime = 0;
            }
        });

        $audio.off();
        $audio.on('playing', function() {
            $playBtn.removeClass(pause).addClass(playing);
        });
        $audio.on('pause', function() {
            $playBtn.removeClass(playing).addClass(pause);
        });
        $audio.on('ended', function() {
            $playBtn.removeClass(playing + ' ' + pause);
        });

        if ($playBtn.hasClass('playing')) {
            $audio.get(0).pause();
        } else {
            $audio.get(0).play();
        }
    });

    SR.dom.$body.on('click.speak', '.J_reuploadVoice', function(e) {
        var $me = $(this).parents('.me');
        var $audio = $me.find('.speak-audio');
        var voiceData = $audio.attr('src');
        var speakId = $me.attr('id');
        if (voiceData) {
            $me.removeClass(uploadVoiceError);
            uploadVoice(voiceData, speakId);
        }
    });
    
    function uploadVoice(voiceData, speakId) {
        var $speak = $('#' + speakId);
        $speak.addClass(vocieUploading);
        $.ajax({
            method: 'POST',
            timeout: 30 * 1000,
            url: API + '/uploadVoice',
            dataType: 'json',
            data: {
                appcid: appcid,
                sn: sn,
                uid: uid,
                voiceData: voiceData,
            }
        }).done(function(data) {
            if (data.ret === 0 && data.url) {
                sendMsg(data.url, 'voice', function() {
                    // success
                }, function(err) {
                    $speak.addClass(uploadVoiceError);
                });
            } else {
                $speak.addClass(uploadVoiceError);
            }
        }).fail(function(err) {
            $speak.addClass(uploadVoiceError);
        }).always(function () {
            $speak.removeClass(vocieUploading);
        });
    }

    // 发送消息
    function sendMsg(content, type, successCb, errorCb) {
        if (!appcid || !appcid.length || !sn || !sn.length || !content || !content.length) {
            return;
        }
        var msgType = type || 'text';
        $.ajax({
            method: 'POST',
            timeout: xhrTimeout,
            url: API + '/send',
            data: {
                appcid: appcid,
                sn: sn,
                uid: uid,
                msgType: msgType,
                content: content,
            }
        }).done(function(data) {
            if (data.ret === 0) {
                successCb && successCb(data);
            } else {
                errorCb && errorCb(data);
            }
        }).fail(function(err) {
            errorCb && errorCb(err);
        })
    }

    window.speak = function(voiceData, options) {
        if (!voiceData) {
            console.log('speak api error: can not found voiceData');
            return;
        }
        options = options || {};
        options.scrollToAnswer = options.scrollToAnswer === undefined ? true : options.scrollToAnswer;
        var $answerContainer = options.answerContainerId ? $('#' + options.answerContainerId) : $wrapper;
        var opt;
        var iVoiceData = voiceData;
        iVoiceData = 'data:audio/mp3;base64,' + iVoiceData;
        // 触发事件
        SR.App.trigger('beforeSpeak', [options]);
        var speakId = 'speakId-' + Date.now();
        // 即时显示问题对话框
        if (options.speakAgain !== 'reload') {
            var templateHTML = template('speak', {
                id: speakId,
                avatar: SR.data.userInfo.userAvatar,
                voiceData: iVoiceData,
            });
            $answerContainer.append(templateHTML);
        }
        // 滑动页面到当前提问位置
        if (options.scrollToAsk !== false) {
            $scrollWrap.stop(false, false).animate({
                scrollTop: $wrapper.height() + $historyWrapper.height() - 30
            }, scrollAnimateDuration);
        }
        // 删除原有答案
        if (options.speakAgain === 'reload') {
            var $dom = $('#' + options.speakId);
            $dom.next('.robot').remove();
        }
        // 请求答案
        opt = {
            speakId: speakId,
            $answerContainer: $answerContainer,
            speakOptions: options
        }
        // 广播 speakFire 事件，用于特定场景处理
        SR.App.trigger('speakFire', [opt]);
        uploadVoice(voiceData, speakId);
    }
}

// var vd = 'UklGRhwMAABXQVZFZm10IBAAAAABAAEAgD4AAIA+AAABAAgAZGF0Ya4LAACAgICAgICAgICAgICAgICAgICAgICAgICAf3hxeH+AfXZ1eHx6dnR5fYGFgoOKi42aloubq6GOjI2Op7ythXJ0eYF5aV1AOFFib32HmZSHhpCalIiYi4SRkZaLfnhxaWptb21qaWBea2BRYmZTVmFgWFNXVVVhaGdbYGhZbXh1gXZ1goeIlot1k6yxtKaOkaWhq7KonKCZoaCjoKWuqqmurK6ztrO7tbTAvru/vb68vbW6vLGqsLOfm5yal5KKhoyBeHt2dXBnbmljVlJWUEBBPDw9Mi4zKRwhIBYaGRQcHBURGB0XFxwhGxocJSstMjg6PTc6PUxVV1lWV2JqaXN0coCHhIyPjpOenqWppK6xu72yxMu9us7Pw83Wy9nY29ve6OPr6uvs6ezu6ejk6erm3uPj3dbT1sjBzdDFuMHAt7m1r7W6qaCupJOTkpWPgHqAd3JrbGlnY1peX1hTUk9PTFRKR0RFQkRBRUVEQkdBPjs9Pzo6NT04Njs+PTxAPzo/Ojk6PEA5PUJAQD04PkRCREZLUk1KT1BRUVdXU1VRV1tZV1xgXltcXF9hXl9eY2VmZmlna3J0b3F3eHyBfX+JgIWJiouTlZCTmpybnqSgnqyrqrO3srK2uL2/u7jAwMLFxsfEv8XLzcrIy83JzcrP0s3M0dTP0drY1dPR1dzc19za19XX2dnU1NjU0dXPzdHQy8rMysfGxMLBvLu3ta+sraeioJ2YlI+MioeFfX55cnJsaWVjXVlbVE5RTktHRUVAPDw3NC8uLyknKSIiJiUdHiEeGx4eHRwZHB8cHiAfHh8eHSEhISMoJyMnKisrLCszNy8yOTg9QEJFRUVITVFOTlJVWltaXmNfX2ZqZ21xb3R3eHqAhoeJkZKTlZmhpJ6kqKeur6yxtLW1trW4t6+us7axrbK2tLa6ury7u7u9u7vCwb+/vr7Ev7y9v8G8vby6vru4uLq+tri8ubi5t7W4uLW5uLKxs7G0tLGwt7Wvs7avr7O0tLW4trS4uLO1trW1trm1tLm0r7Kyr66wramsqaKlp52bmpeWl5KQkImEhIB8fXh3eHJrbW5mYGNcWFhUUE1LRENDQUI9ODcxLy8vMCsqLCgoKCgpKScoKCYoKygpKyssLi0sLi0uMDIwMTIuLzQ0Njg4Njc8ODlBQ0A/RUdGSU5RUVFUV1pdXWFjZGdpbG1vcXJ2eXh6fICAgIWIio2OkJGSlJWanJqbnZ2cn6Kkp6enq62srbCysrO1uLy4uL+/vL7CwMHAvb/Cvbq9vLm5uba2t7Sysq+urqyqqaalpqShoJ+enZuamZqXlZWTkpGSkpCNjpCMioqLioiHhoeGhYSGg4GDhoKDg4GBg4GBgoGBgoOChISChISChIWDg4WEgoSEgYODgYGCgYGAgICAgX99f398fX18e3p6e3t7enp7fHx4e3x6e3x7fHx9fX59fn1+fX19fH19fnx9fn19fX18fHx7fHx6fH18fXx8fHx7fH1+fXx+f319fn19fn1+gH9+f4B/fn+AgICAgH+AgICAgIGAgICAgH9+f4B+f35+fn58e3t8e3p5eXh4d3Z1dHRzcXBvb21sbmxqaWhlZmVjYmFfX2BfXV1cXFxaWVlaWVlYV1hYV1hYWVhZWFlaWllbXFpbXV5fX15fYWJhYmNiYWJhYWJjZGVmZ2hqbG1ub3Fxc3V3dnd6e3t8e3x+f3+AgICAgoGBgoKDhISFh4aHiYqKi4uMjYyOj4+QkZKUlZWXmJmbm52enqCioqSlpqeoqaqrrK2ur7CxsrGys7O0tbW2tba3t7i3uLe4t7a3t7i3tre2tba1tLSzsrKysbCvrq2sq6qop6alo6OioJ+dnJqZmJeWlJKSkI+OjoyLioiIh4WEg4GBgH9+fXt6eXh3d3V0c3JxcG9ubWxsamppaWhnZmVlZGRjYmNiYWBhYGBfYF9fXl5fXl1dXVxdXF1dXF1cXF1cXF1dXV5dXV5fXl9eX19gYGFgYWJhYmFiY2NiY2RjZGNkZWRlZGVmZmVmZmVmZ2dmZ2hnaGhnaGloZ2hpaWhpamlqaWpqa2pra2xtbGxtbm1ubm5vcG9wcXBxcnFycnN0c3N0dXV2d3d4eHh5ent6e3x9fn5/f4CAgIGCg4SEhYaGh4iIiYqLi4uMjY2Oj5CQkZGSk5OUlJWWlpeYl5iZmZqbm5ybnJ2cnZ6en56fn6ChoKChoqGio6KjpKOko6SjpKWkpaSkpKSlpKWkpaSlpKSlpKOkpKOko6KioaKhoaCfoJ+enp2dnJybmpmZmJeXlpWUk5STkZGQj4+OjYyLioqJh4eGhYSEgoKBgIB/fn59fHt7enl5eHd3dnZ1dHRzc3JycXBxcG9vbm5tbWxrbGxraWppaWhpaGdnZ2dmZ2ZlZmVmZWRlZGVkY2RjZGNkZGRkZGRkZGRkZGRjZGRkY2RjZGNkZWRlZGVmZWZmZ2ZnZ2doaWhpaWpra2xsbW5tbm9ub29wcXFycnNzdHV1dXZ2d3d4eXl6enp7fHx9fX5+f4CAgIGAgYGCgoOEhISFhoWGhoeIh4iJiImKiYqLiouLjI2MjI2OjY6Pj46PkI+QkZCRkJGQkZGSkZKRkpGSkZGRkZKRkpKRkpGSkZKRkpGSkZKRkpGSkZCRkZCRkI+Qj5CPkI+Pjo+OjY6Njo2MjYyLjIuMi4qLioqJiomJiImIh4iHh4aHhoaFhoWFhIWEg4SDg4KDgoKBgoGAgYCBgICAgICAf4CAf39+f35/fn1+fX59fHx9fH18e3x7fHt6e3p7ent6e3p5enl6enl6eXp5eXl4eXh5eHl4eXh5eHl4eXh5eHh3eHh4d3h4d3h3d3h4d3l4eHd4d3h3eHd4d3h3eHh4eXh5eHl4eHl4eXh5enl6eXp5enl6eXp5ent6ent6e3x7fHx9fH18fX19fn1+fX5/fn9+f4B/gH+Af4CAgICAgIGAgYCBgoGCgYKCgoKDgoOEg4OEg4SFhIWEhYSFhoWGhYaHhoeHhoeGh4iHiIiHiImIiImKiYqJiYqJiouKi4qLiouKi4qLiouKi4qLiouKi4qLi4qLiouKi4qLiomJiomIiYiJiImIh4iIh4iHhoeGhYWGhYaFhIWEg4OEg4KDgoOCgYKBgIGAgICAgH+Af39+f359fn18fX19fHx8e3t6e3p7enl6eXp5enl6enl5eXh5eHh5eHl4eXh5eHl4eHd5eHd3eHl4d3h3eHd4d3h3eHh4d3h4d3h3d3h5eHl4eXh5eHl5eXp5enl6eXp7ent6e3p7e3t7fHt8e3x8fHx9fH1+fX59fn9+f35/gH+AgICAgICAgYGAgYKBgoGCgoKDgoOEg4SEhIWFhIWFhoWGhYaGhoaHhoeGh4aHhoeIh4iHiIeHiIeIh4iHiIeIiIiHiIeIh4iHiIiHiIeIh4iHiIeIh4eIh4eIh4aHh4aHhoeGh4aHhoWGhYaFhoWFhIWEhYSFhIWEhISDhIOEg4OCg4OCg4KDgYKCgYKCgYCBgIGAgYCBgICAgICAgICAf4B/f4B/gH+Af35/fn9+f35/fn1+fn19fn1+fX59fn19fX19fH18fXx9fH18fXx9fH18fXx8fHt8e3x7fHt8e3x7fHt8e3x7fHt8e3x7fHt8e3x7fHt8e3x8e3x7fHt8e3x7fHx8fXx9fH18fX5+fX59fn9+f35+f35/gH+Af4B/gICAgICAgICAgICAgYCBgIGAgIGAgYGBgoGCgYKBgoGCgYKBgoGCgoKDgoOCg4KDgoOCg4KDgoOCg4KDgoOCg4KDgoOCg4KDgoOCg4KDgoOCg4KDgoOCg4KDgoOCg4KDgoOCg4KCgoGCgYKBgoGCgYKBgoGCgYKBgoGCgYKBgoGCgYKBgoGCgYKBgoGCgYKBgoGBgYCBgIGAgYCBgIGAgYCBgIGAgYCBgIGAgYCBgIGAgYCAgICBgIGAgYCBgIGAgYCBgIGAgYCBgExJU1RCAAAASU5GT0lDUkQMAAAAMjAwOC0wOS0yMQAASUVORwMAAAAgAAABSVNGVBYAAABTb255IFNvdW5kIEZvcmdlIDguMAAA';
})();